import {create} from 'zustand';
import {CancelSignUpFlowStore} from './types';

const useCancelSignUpFlowStore = create<CancelSignUpFlowStore>(set => ({
	modalState: false,
	setModalState: value => set({modalState: value}),
	resetModalState: () => set({modalState: false}),
}));

export {useCancelSignUpFlowStore};
